module.exports = __webpack_public_path__ + "media/images/icons/miss-alt-22da50c93a370a087397a7a0c063537d.png";